import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ClipLoader from "react-spinners/ClipLoader";
import DropdownButton from "react-bootstrap/DropdownButton";

import { TIME_OPTIONS } from "../../constants/index.js"

export class ExecutableState extends Component {

  renderMapName(name) {
    return name.substring(Math.max(name.lastIndexOf("/"), name.lastIndexOf("#")) + 1);
  }

  msToHMS(ms) {
  // 1- Convert to seconds:
  var seconds = ms / 1000;

  // 2- Extract hours:
  var hours = parseInt(seconds / 3600); // 3600 seconds in 1 hour
  seconds = parseInt(seconds % 3600); // extract the remaining seconds after extracting hours

  // 3- Extract minutes:
  var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute

  // 4- Keep only seconds not extracted to minutes:
  seconds = parseInt(seconds % 60);

  // 5 - Format so it shows a leading zero if needed
  let hoursStr
  if (hours < 60) {
    hoursStr = ("00" + hours).slice(-2);
  } else {
    hoursStr = hours + "";
  }
  let minutesStr = ("00" + minutes).slice(-2);
  let secondsStr = ("00" + seconds).slice(-2);

  return hoursStr + ":" + minutesStr + ":" + secondsStr
}

  render() {

    var time = null;
    var cz
    var ct
    var message = null;
    if (this.props.value.messages && this.props.value.messages.length > 0) {
        message = this.props.value.messages[0].message
    }
    var diff = null;

    // console.log(this.props.value)

    if (this.props.value.state === 'NOT_EXECUTED') {
      cz = 'not-executed'
      ct = 'Not executed'
    } else if (this.props.value.state === 'EXECUTING') {
      cz = 'executing'
      ct = 'Executing'
      time = 'since ' + new Date(this.props.value.startedAt).toLocaleDateString('en-UK', TIME_OPTIONS);
    } else if (this.props.value.state === 'EXECUTED') {
      cz = 'executed'
      ct = 'Executed'
      time = 'at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS)
      diff = this.msToHMS(new Date(this.props.value.completedAt) - new Date(this.props.value.startedAt));
    } else if (this.props.value.state === 'EXECUTION_FAILED') {
      cz = 'failed'
      ct = 'Execution failed'
      time = 'at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS);
    } else {
      cz = 'not-executed'
      ct = 'Not executed'
    }
     // console.log(this.props.value);

    return (
      <div>
        <div className={cz}>
          {ct}
        </div>
        {this.props.value.stateMessage &&
          <div className="submessage">
            {this.props.value.stateMessage}
          </div>}
        <div>
          {time &&
            <Row className="executeinfo">
              <Col md="12">
                <span className='times'>({time}</span>{diff && <span className='times'>,in </span>}{diff && <span className='time-crimson'> {diff}</span>}<span className='times'>)</span>
                {this.props.value.count != undefined &&
                <span className='times pl-4'>items: {this.props.value.count}</span>}
              </Col>
            </Row>}
          {message &&
            <Row className="executeinfo">
              <Col md="auto">
                <span className='times crimson-std'>{message}</span>
              </Col>
            </Row>}
          {this.props.value.progress && this.props.value.progress.length > 0 &&
            <Container className='executingtable'>
            <Row>
              <Col md={5} className='executinginfo'>Mapping</Col>
              <Col md={3} className='executinginfo'>Total</Col>
              <Col md={2} className='executinginfo'>Failed</Col>
              <Col md={1} className='executinginfo'></Col>
              <Col md={1} className='executinginfo'></Col>
              {/* <Col className='executinginfo'> {this.renderMapName(m.triplesMap)}</Col>
              <Col className='executinginfo'> {this.renderMapName(m.dataSource)}</Col> */}
              {/* <Col className='executinginfo'>{m.key}</Col> */}
            </Row>
              {this.props.value.progress.map((m, index) =>
                  <Row key={index}>
                    {/* <Col md='auto' className='executinginfo'>{m.partialCount ? m.partialCount : ''}</Col> */}
                    <Col md={5} className='executinginfo'> {this.renderMapName(m.triplesMap)}</Col>
                    {(!m.totalItems || m.totalCount == m.totalItems) &&
                    <Col md={3} className='executinginfo executed '>{m.totalCount ? m.totalCount - m.failures : ''}</Col>}
                    {(m.totalItems > 0 && m.totalCount != m.totalItems) &&
                    <Col md={3}>
                      <Row><Col className='executinginfo executed '>{m.totalCount ? m.totalCount - m.failures : ''}</Col></Row>
                      <Row><Col className='executinginfo'>/<span className="totalcount">{m.totalItems}</span></Col></Row>
                      {m.started && !m.completed && !m.failed &&
                        <Row><Col className='executinginfo'>{this.msToHMS((new Date() - new Date(this.props.value.startedAt))*(m.totalItems/m.totalCount - 1))}</Col></Row>}
                    </Col>}
                    <Col md={2} className='executinginfo failed'>{m.totalCount ? m.failures : ''}</Col>
                    <Col md={1} className="executinginfobutton">
                      {m.messages && m.messages.length > 0 &&
                      <DropdownButton size="sm"  title={<span title="Show errors" className='fa fa-info'></span>} className="actions">
                        <div className="execution-errors">
                          <span>Errors{m.messages.length < m.failures ? ' (first 5)':''}:</span>
                          {m.messages.map((msg,mindex) =>
                          <Row className="pb-2">
                            <Col>
                              <span className='times crimson-std'>{msg.message}</span>
                            </Col>
                          </Row>)}
                        </div>
                      </DropdownButton>}
                    </Col>
                    <Col md={1} className="executinginfo pl-1">
                      {m.started && !m.completed && !m.failed &&
                        <ClipLoader
                        css='spinner'
                          size={10}
                          color='orange'
                          loading={true}
                        />}
                      {m.started && m.completed &&
                        <span className="fa fa-check"></span>
                      }
                      {m.failed &&
                        <span className="fa fa-times failed"></span>
                      }
                    </Col>
                  </Row>
              )}
            </Container>}
        </div>
      </div>
    )
  }
}

export default ExecutableState;
